import { AnnuityHistogramChartTooltip } from './annuity-histogram-chart-tooltip';
import { AreaSplineCurrencyTooltip } from './area-spline-currency.tooltip';
import { CategoryPointTooltip } from './category-point.tooltip';
import { CurrencyAndPercentageTooltip } from './currency-and-percentage.tooltip';
import { DecumHistogramChartTooltip } from './decum-histogram-chart-tooltip';
import { DecumSavingsChartTooltip } from './decum-savings-chart.tooltip';
import { FundAnalyticsLineChartTooltip } from './fund-analytics-line-chart.tooltip';
import { LineChartTooltip } from './line-chart.tooltip';
import { PercentageTooltip } from './percentage.tooltip';
import { SeriesCategoryPointTooltip } from './series-category-point.tooltip';
import { SeriesPointTooltip } from './series-point.tooltip';

/**
 * TooltipDispatcher dispatches the correct tooltip based on the tooltipType - if this is not supplied the fallback is: the chartType.
 * @param {string} chartType the type of chart.
 * @param {string} tooltipType the tooltip type.
 */
export class TooltipDispatcher {
	private _selector: string;
	constructor(chartType: string, tooltipType?: string) {
		this._selector = tooltipType ? tooltipType.toLowerCase() : chartType.toLowerCase();
	}

	public getTooltipFormatter(tooltipParams?: {
		multiplier?: number;
		displayCurrency?: string;
		customData?: any;
	}): Function {
		switch (this._selector) {
			case 'line':
				return LineChartTooltip.getFormatter();
			case 'fund-analytics-line':
				return FundAnalyticsLineChartTooltip.getFormatter();
			case 'percentage':
				return PercentageTooltip.getFormatter();
			case 'area-spline-currency':
				return AreaSplineCurrencyTooltip.getFormatter(tooltipParams?.displayCurrency, tooltipParams?.customData);
			case 'currency-and-percentage':
				return CurrencyAndPercentageTooltip.getFormatter(tooltipParams?.multiplier, tooltipParams?.displayCurrency);
			case 'decum-histogram-chart':
				return DecumHistogramChartTooltip.getFormatter(tooltipParams?.customData, tooltipParams?.displayCurrency);
			case 'annuity-histogram-chart':
				return AnnuityHistogramChartTooltip.getFormatter(tooltipParams?.customData, tooltipParams?.displayCurrency);
			case 'decum-savings-chart':
				return DecumSavingsChartTooltip.getFormatter(tooltipParams?.customData, tooltipParams?.displayCurrency);
			case 'series-category-point':
				return SeriesCategoryPointTooltip.getFormatter();
			case 'category-point':
				return CategoryPointTooltip.getFormatter();
			case 'bar':
			case 'pie':
			case 'doughnut':
			case 'series-point':
				return SeriesPointTooltip.getFormatter();
		}
	}
}
